import { jsxs as v, jsx as d } from "react/jsx-runtime";
import { useRef as g, useState as E, useMemo as R, useCallback as D, useEffect as k } from "react";
import { buildClassNames as o } from "../../style/build-class-names.mjs";
import { FlagEmoji as A } from "../flag-emoji/flag-emoji.mjs";
import { CloseIcon as K } from "../../../../../icons/close-icon.mjs";
import { defaultCountries as T } from "../../constants/default-countries.mjs";
import { parseCountry as m } from "../../utils/country-utils/parse-country.mjs";
import { scrollToChild as U } from "../../utils/common/scroll-to-child.mjs";
const V = ({
  show: N,
  dialCodePrefix: S = "+",
  selectedCountry: c,
  countries: I = T,
  onSelect: f,
  onClose: p,
  searchInputPlaceholder: q,
  ...t
}) => {
  const x = g(null), y = g(null), _ = g(void 0), [u, F] = E(""), a = R(() => {
    if (u) {
      const e = u.toLowerCase();
      return I.filter(([r]) => r.toLowerCase().includes(e));
    } else
      return I;
  }, [I, u]), C = D(
    (e) => a.findIndex((r) => m(r).iso2 === e),
    [a]
  ), [n, h] = E(C(c)), b = () => {
    _.current !== c && h(C(c));
  }, $ = D(
    (e) => {
      h(C(e.iso2)), f == null || f(e);
    },
    [f, C]
  ), w = (e) => {
    const r = a.length - 1, s = (l) => e === "prev" ? l - 1 : e === "next" ? l + 1 : e === "last" ? r : 0;
    h((l) => {
      const i = s(l);
      return i < 0 ? 0 : i > r ? r : i;
    });
  }, L = (e) => {
    if (e.stopPropagation(), e.key === "Enter") {
      const r = m(a[n]);
      $(r);
      return;
    }
    if (e.key === "Escape") {
      p == null || p();
      return;
    }
    if (e.key === "ArrowUp") {
      e.preventDefault(), w("prev");
      return;
    }
    if (e.key === "ArrowDown") {
      e.preventDefault(), w("next");
      return;
    }
    if (e.key === "PageUp") {
      e.preventDefault(), w("first");
      return;
    }
    if (e.key === "PageDown") {
      e.preventDefault(), w("last");
      return;
    }
    e.key === " " && e.preventDefault();
  }, j = D(() => {
    if (!y.current || n === void 0 || !a[n])
      return;
    const e = m(a[n]).iso2;
    if (e === _.current) return;
    const r = y.current.querySelector(`[data-country="${e}"]`);
    r && (U(y.current, r), _.current = e);
  }, [n, a]);
  return k(() => {
    j();
  }, [n, j]), k(() => {
    x.current && (N ? Promise.resolve().then(() => {
      var e;
      return (e = x.current) == null ? void 0 : e.focus();
    }) : b());
  }, [N]), k(() => {
    b();
  }, [c]), /* @__PURE__ */ v(
    "div",
    {
      className: o({
        addPrefix: ["country-selector-dropdown"],
        rawClassNames: [t.className]
      }),
      style: { display: N ? "block" : "none", ...t.style },
      tabIndex: -1,
      "aria-activedescendant": `${a[n] && m(a[n]).iso2}-option`,
      onBlur: p,
      children: [
        /* @__PURE__ */ d(
          "input",
          {
            ref: x,
            className: o({
              addPrefix: ["country-selector-dropdown__search-input"],
              rawClassNames: [t.searchInputClassName]
            }),
            placeholder: q || "",
            style: t.searchInputStyle,
            type: "text",
            value: u,
            onChange: (e) => F(e.target.value),
            onKeyDown: L
          }
        ),
        u && /* @__PURE__ */ d(
          K,
          {
            onClick: () => F(""),
            className: o({
              addPrefix: ["country-selector-dropdown__clear-search-input"],
              rawClassNames: [t.clearSearchInputClassName]
            }),
            style: t.clearSearchInputStyle
          }
        ),
        /* @__PURE__ */ d(
          "ul",
          {
            ref: y,
            role: "listbox",
            className: o({
              addPrefix: ["country-selector-dropdown__list"],
              rawClassNames: [t.listClassName]
            }),
            style: t.listStyle,
            children: a.map((e, r) => {
              const s = m(e), l = s.iso2 === c, i = r === n;
              return /* @__PURE__ */ v(
                "li",
                {
                  "data-country": s.iso2,
                  "data-focused": i,
                  role: "option",
                  "aria-selected": l,
                  "aria-label": `${s.name} ${S}${s.dialCode}`,
                  id: `${s.iso2}-option`,
                  className: o({
                    addPrefix: [
                      "country-selector-dropdown__list-item",
                      l && "country-selector-dropdown__list-item--selected",
                      i && "country-selector-dropdown__list-item--focused"
                    ],
                    rawClassNames: [t.listItemClassName]
                  }),
                  onClick: () => $(s),
                  style: t.listItemStyle,
                  children: [
                    /* @__PURE__ */ d(
                      A,
                      {
                        iso2: s.iso2,
                        className: o({
                          addPrefix: ["country-selector-dropdown__list-item-flag-emoji"],
                          rawClassNames: [t.listItemFlagClassName]
                        }),
                        style: t.listItemFlagStyle
                      }
                    ),
                    /* @__PURE__ */ d(
                      "span",
                      {
                        className: o({
                          addPrefix: ["country-selector-dropdown__list-item-country-name"],
                          rawClassNames: [t.listItemCountryNameClassName]
                        }),
                        style: t.listItemCountryNameStyle,
                        children: s.name
                      }
                    ),
                    /* @__PURE__ */ v(
                      "span",
                      {
                        className: o({
                          addPrefix: ["country-selector-dropdown__list-item-dial-code"],
                          rawClassNames: [t.listItemDialCodeClassName]
                        }),
                        style: t.listItemDialCodeStyle,
                        children: [
                          S,
                          s.dialCode
                        ]
                      }
                    )
                  ]
                },
                s.iso2
              );
            })
          }
        )
      ]
    }
  );
};
export {
  V as CountrySelectorDropdown
};
